import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import { BottomToolbarRes } from '@/types/api/hall/bottom-toolbar.d';

export const getBottomToolbar = () =>
  get<BottomToolbarRes>('/hall/toolbar/v1/bottom_toolbar');

const { useQueryHook: useGetBottomToolbar } = createApiQuery(getBottomToolbar, () => ['bottom-toolbar']);
export { useGetBottomToolbar };